import { TableCell, Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';
import React, { FC, memo } from 'react';
import { classNames } from 'react-extras';
import { FormattedTime } from 'react-intl';
import { useSelector } from 'react-redux';

import { makeSelectTableColumnWidths } from 'containers/ApplicantTableV2/selectors';
import { TableColumnWidthsKey } from 'containers/ApplicantTableV2/types';

import useStyles from './styles';

export interface ApplicantTableV2DateTimeCellProps {
  datetime?: string | null;
  timezone?: string;
  columnType: TableColumnWidthsKey;
  textAlign: TypographyProps['align'];
}

const ApplicantTableV2DateTimeCell: FC<ApplicantTableV2DateTimeCellProps> = ({
  datetime,
  columnType,
  textAlign,
}) => {
  const styles = useStyles();
  const tableColumnWidths = useSelector(makeSelectTableColumnWidths());

  return (
    <TableCell
      role="cell"
      style={{
        minWidth: tableColumnWidths[columnType],
        maxWidth: tableColumnWidths[columnType],
      }}
      className={classNames(styles.td)}
    >
      {datetime ? (
        <Typography
          variant="caption"
          className={styles.dateText}
          align={textAlign}
        >
          <FormattedTime
            dateStyle="short"
            timeStyle="short"
            value={new Date(datetime)}
          />
        </Typography>
      ) : null}
    </TableCell>
  );
};

export default memo(ApplicantTableV2DateTimeCell);
